import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminSidebar from './components/AdminSidebar';
import OverviewSection from './components/OverviewSection';
import InquiriesSection from './components/InquiriesSection';
import TutorsSection from './components/TutorsSection';
import StudentsSection from './components/StudentsSection';
import EventsAdminSection from './components/EventsAdminSection';
import ResourcesAdminSection from './components/ResourcesAdminSection';
import AdminBlogs from './components/AdminBlogs';
import SettingsSection from './components/SettingsSection';

export default function AdminDashboardPage() {
  const [activeSection, setActiveSection] = useState('overview');
  const [activeSubSection, setActiveSubSection] = useState<string | null>(null);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const userStr = localStorage.getItem('user');
      const token = localStorage.getItem('token');
      if (!userStr || !token) {
        navigate('/admin/login', { replace: true });
        return;
      }
      const user = JSON.parse(userStr);
      if (user.role !== 'admin') {
        navigate('/admin/login', { replace: true });
        return;
      }
    } catch (e) {
      navigate('/admin/login', { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    // Determine section and optional subsection from pathname: /admin/dashboard/<section>/<sub>
    const parts = location.pathname.split('/').filter(Boolean);
    const dashboardIndex = parts.indexOf('dashboard');
    const section = dashboardIndex >= 0 && parts.length > dashboardIndex + 1 ? parts[dashboardIndex + 1] : 'overview';
    const sub = dashboardIndex >= 0 && parts.length > dashboardIndex + 2 ? parts[dashboardIndex + 2] : null;
    setActiveSection(section);
    setActiveSubSection(sub);
  }, [location.pathname]);

  // If user navigates to base /admin/dashboard, ensure URL shows overview path
  useEffect(() => {
    const parts = location.pathname.split('/').filter(Boolean);
    const dashboardIndex = parts.indexOf('dashboard');
    if (dashboardIndex >= 0 && parts.length === dashboardIndex + 1) {
      navigate('/admin/dashboard/overview', { replace: true });
    }
  }, []);

  const renderSection = () => {
    switch (activeSection) {
      case 'overview': return <OverviewSection />;
      case 'inquiries': return <InquiriesSection />;
      case 'tutors': return <TutorsSection />;
      case 'students': return <StudentsSection />;
      case 'events': return <EventsAdminSection />;
      case 'resources': return <ResourcesAdminSection activeSubSection={activeSubSection} />;
      case 'blog': return <AdminBlogs />;
      case 'settings': return <SettingsSection />;
      default: return <OverviewSection />;
    }
  };

  return (
    <div className="flex min-h-screen bg-slate-50">
      <AdminSidebar activeSection={activeSection} activeSubSection={activeSubSection} onSelect={setActiveSection} />
      <main className="flex-1 p-6 lg:p-8 overflow-auto">
        {renderSection()}
      </main>
    </div>
  );
}
